<h2 mat-dialog-title>
  {{ data.action === 'activate' ? ('account.dialogs.mfa.manage.title.activate' | t) : ('account.dialogs.mfa.manage.title.deactivate' | t) }}
  <span *ngIf="data.mfa?.name">({{ data.mfa?.name }})</span>
</h2>
<mat-dialog-content class="mat-typography">
  <sn-alert
    dense
    class="alert-rounded"
    type="danger"
    *ngIf="deactivateForm.errors || activateForm.errors"
  >
    <ng-container *ngIf="data.action === 'activate'">
      <div *ngFor="let error of activateForm.errors | keyvalue">
        <b>{{ toStartCase(error.key) }}</b
        >:
        <ng-container *ngIf="isArray(error.value); else singleError">
          <ul class="error-list">
            <li *ngFor="let item of error.value">{{ item }}</li>
          </ul>
        </ng-container>
        <ng-template #singleError>
          <ul class="error-list">
            <li>{{ error.value }}</li>
          </ul>
        </ng-template>
        <ul class="error-list">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngIf="data.action === 'deactivate'">
      <div *ngFor="let error of deactivateForm.errors | keyvalue">
        <b>{{ toStartCase(error.key) }}</b
        >:
        <ng-container *ngIf="isArray(error.value); else singleError">
          <ul class="error-list">
            <li *ngFor="let item of error.value">{{ item }}</li>
          </ul>
        </ng-container>
        <ng-template #singleError>
          <ul class="error-list">
            <li>{{ error.value }}</li>
          </ul>
        </ng-template>
        <ul class="error-list">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </div>
    </ng-container>
  </sn-alert>
  <ng-container *ngIf="data.action === 'activate'; else deactivateTmpl">
    <div class="subTitleHeader">
      <h2>{{ 'account.dialogs.mfa.manage.setupTitle' | t }}</h2>
    </div>
    <mat-divider></mat-divider>
            <h3>{{ 'account.dialogs.mfa.manage.scanInstructions' | t }}</h3>
    <qrcode
      *ngIf="qrCodeUrl"
      colorLight="#141217"
      colorDark="#FFCA28"
      [qrdata]="qrCodeUrl"
      [width]="256"
      [errorCorrectionLevel]="'M'"
    ></qrcode>
    <br />
    <h3>
      {{ 'account.dialogs.mfa.manage.codeInstructions' | t }}
    </h3>
    <sn-form [form]="activateForm" [fields]="formFields" [(model)]="formModel"></sn-form>
  </ng-container>

  <ng-template #deactivateTmpl>
    <p>{{ 'account.dialogs.mfa.manage.deactivateInstructions' | t }}</p>
    <sn-form [form]="deactivateForm" [fields]="formFields" [model]="formModel"></sn-form>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
          <button mat-button mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button
    mat-button
    *ngIf="data.action === 'activate'"
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    [disabled]="activateForm.invalid"
    color="success"
    (click)="submitForm()"
  >
    {{ 'common.activate' | t }}
  </button>
  <button
    mat-button
    *ngIf="data.action === 'deactivate'"
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    [disabled]="deactivateForm.invalid"
    color="warn"
    (click)="submitForm()"
  >
    {{ 'common.deactivate' | t }}
  </button>
</mat-dialog-actions>
